<template>
  <app-frame>
    <template v-slot:sidebar>
      <li>
        <router-link class="nav-link"
          active-class="active"
          :to="{ name: 'VAEList' }"
          exact>
          <i class="fa fa-fw fa-list"></i>List</router-link>
      </li>
    </template>
    <template slot="main">
      <HospitalSwitcher></HospitalSwitcher>
      <router-view></router-view>
    </template>
  </app-frame>
</template>
<script>
import AppFrame from '@/components/AppFrame'
import axios from 'axios'
import axiosConfig from '@/common/axiosConfig'
import HospitalSwitcher from '@/components/shared/HospitalSwitcher'
import { mapGetters } from 'vuex'

export default {
  name: 'CovidChartFrame',
  components: {
    'app-frame': AppFrame,
    HospitalSwitcher
  },
  computed: {
    ...mapGetters(['currentHospital']),
    config () {
      return this.$store.state.issue_tracker_config
    }
  },
  mounted () {
    axios.get(`issue-tracker/hospital/${this.currentHospital.code}/config`, axiosConfig).then(response => {
      this.$store.commit('populate_issue_tracker_config', response.data)
    })
  }
}
</script>
<style scoped>
</style>
